var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TileBase',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"image",fn:function(){return [_vm._t("image")]},proxy:true}],null,true)},'TileBase',_vm.$attrs,false),_vm.$listeners),[_c('div',{class:_vm.$style.text},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }